export default "<p appI18n=\"@@driver-score-chartsWorks\">driver-score-charts works!</p>\n"